import { combineEpics } from 'redux-observable';
import { closeOrderLifetimeBeforeRemoveEpic } from './_epics/closeOrderLifetimeBeforeRemove.epic';
import { reloadOrderLifetimeListEpic } from './_epics/reloadOrderLifetimeList.epic';
import { toggleViewPricingProfileSidebarEpic } from './_epics/toggleViewOrderLifetimeSidebar.epic';

export const controllerOrderLifitimeEpic = combineEpics(
  closeOrderLifetimeBeforeRemoveEpic,
  reloadOrderLifetimeListEpic,
  toggleViewPricingProfileSidebarEpic,
);
